import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'stena-button',
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './stena-button.component.html',
  styleUrls: ['./stena-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class StenaButtonComponent {
  @Input() color = 'primary';
  @Input() text = '';
  @Input() type:
    | 'simple'
    | 'raised'
    | 'fab'
    | 'icon'
    | 'icon-text'
    | 'stroked' = 'simple';
  @Input() buttonType: 'submit' | 'reset' | 'button' = 'button';
  @Input() icon = '';
  @Input() disabled = false;

  @Output() buttonClick = new EventEmitter<MouseEvent>();

  onButtonClick(event: MouseEvent): void {
    if (this.disabled) {
      console.log('Button is disabled. Click event will not be emitted.');
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.buttonClick.emit(event);
  }
}
